import {
  ENTRY_CATEGORIES,
  STANDARD_HOURS_CATEGORY,
} from './constants';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/**
 * Display work date as day/month/year with weekday, e.g. "Thu 21/08/2026".
 * Always DD/MM/YYYY (UK), never locale-dependent MM/DD.
 * Returns '' if invalid.
 */
export function formatWorkDateDisplay(workDate) {
  if (!workDate || typeof workDate !== 'string') return '';
  const parts = workDate.split('-');
  if (parts.length !== 3) return workDate;
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const d = Number(parts[2]);
  if (!y || !m || !d) return workDate;
  const dt = new Date(y, m - 1, d, 12, 0, 0);
  if (Number.isNaN(dt.getTime())) return workDate;
  const dd = String(d).padStart(2, '0');
  const mm = String(m).padStart(2, '0');
  return `${WEEKDAYS[dt.getDay()]} ${dd}/${mm}/${y}`;
}

/**
 * Excel Day column (short weekday only), for IRIS-friendly separate column.
 */
export function formatWorkWeekday(workDate) {
  if (!workDate || typeof workDate !== 'string') return '';
  const parts = workDate.split('-');
  if (parts.length !== 3) return '';
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const d = Number(parts[2]);
  const dt = new Date(y, m - 1, d, 12, 0, 0);
  if (Number.isNaN(dt.getTime())) return '';
  return WEEKDAYS[dt.getDay()];
}

/**
 * Category shown to FM / lists.
 * A timed category keeps its own label. Standard Hours is only the checkbox day.
 */
export function formatCategoryLabel(entry) {
  if (!entry) return '';
  if (entry.category === 'day_sheet') {
    const labels = (entry.sections || [])
      .map(section => section.label)
      .filter(Boolean);
    return labels.length ? labels.join(', ') : 'Day sheet';
  }
  if (
    entry.workedStandardHours ||
    entry.category === STANDARD_HOURS_CATEGORY
  ) {
    return 'Standard Hours';
  }
  if (
    entry.category &&
    entry.category !== STANDARD_HOURS_CATEGORY &&
    entry.category !== 'day_sheet'
  ) {
    const timed = ENTRY_CATEGORIES.find(c => c.value === entry.category);
    if (timed) return timed.label;
  }
  const meta = ENTRY_CATEGORIES.find(c => c.value === entry.category);
  if (meta) return meta.label;
  if (!entry.category) return '';
  return String(entry.category)
    .split('_')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

const rateWord = multiplier => {
  if (Number(multiplier) === 2) return '2.0×';
  if (Number(multiplier) === 1.5) return '1.5×';
  return '1×';
};

/** "2 hours at 1.5× and 6.5 hours at 2.0×" */
export function formatBandHours(segments) {
  if (!Array.isArray(segments) || !segments.length) return '';
  const parts = segments.map(segment => {
    const hours = segment.hours;
    const unit = Number(hours) === 1 ? 'hour' : 'hours';
    return `${hours} ${unit} at ${rateWord(segment.multiplier)}`;
  });
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;
  return `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}
